/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    SimilarRequestObjectionVariant,
    SimilarRequestObjectionVariantFromJSON,
    SimilarRequestObjectionVariantToJSON,
} from './SimilarRequestObjectionVariant';
/**
 * 
 * @export
 * @interface SimilarRequestObjection
 */
export interface SimilarRequestObjection {
    /**
     * 
     * @type {number}
     * @memberof SimilarRequestObjection
     */
    objectionId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SimilarRequestObjection
     */
    variants?: Array<number> | null;
    /**
     * 
     * @type {Array<SimilarRequestObjectionVariant>}
     * @memberof SimilarRequestObjection
     */
    variantDetails?: Array<SimilarRequestObjectionVariant> | null;
}

export function SimilarRequestObjectionFromJSON(json: any): SimilarRequestObjection {
    return SimilarRequestObjectionFromJSONTyped(json, false);
}

export function SimilarRequestObjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarRequestObjection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectionId': !exists(json, 'objectionId') ? undefined : json['objectionId'],
        'variants': !exists(json, 'variants') ? undefined : json['variants'],
        'variantDetails': !exists(json, 'variantDetails') ? undefined : (json['variantDetails'] === null ? null : (json['variantDetails'] as Array<any>).map(SimilarRequestObjectionVariantFromJSON)),
    };
}

export function SimilarRequestObjectionToJSON(value?: SimilarRequestObjection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objectionId': value.objectionId,
        'variants': value.variants,
        'variantDetails': value.variantDetails === undefined ? undefined : (value.variantDetails === null ? null : (value.variantDetails as Array<any>).map(SimilarRequestObjectionVariantToJSON)),
    };
}


